export const ConfigMantenedorCesion = {
	barraBusqueda: {
		criterios: ["Nombre Persona Autorizada", "Rut Persona Autorizada", "Folio Factura"],
		criteriosKeys: ["nombrePersonaAutorizada", "rutPersonaAutorizada", "folio"],
		criterioPrincipal: "Nombre Persona Autorizada",
		datePicker: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Mantenedor Cesion",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
